export const CLOSE_GLOBAL_MESSAGE = 'CLOSE_GLOBAL_MESSAGE'

export default () => {
  return {
    type: CLOSE_GLOBAL_MESSAGE,
  }
}
